import APICall from "../utils/APICall"

export default class ApplicationSettServices{
    static listAppSetting = async () => {
        return await APICall("/api/ApplicationSettings/admin/get-all-applications", "GET")
    }
    static updateSetting = async (payload) => {
        return await APICall("/api/ApplicationSettings/admin/update-application-settings","POST", payload)
    }
}